module.exports = __webpack_public_path__ + "img/Forgot-link-expire-BP.b440541b.png";